<template>
	<button
		class="btn-action-image"
		:class="{'btn-green': action.green}"
		@click="$emit('open-modal')">
		<v-layout wrap class="content-btn">
			<v-flex md12 class="text-desktop">
				<p>{{ action.title}}</p>
			</v-flex>
			<v-flex md12 xs4>
				<img 
					:src="action.image" 
					:alt="action.title" 
					height="61"
					class="image">
			</v-flex>
			<v-flex xs12 md8 sm12 class="text text-mobile">{{ action.title }}</v-flex>
		</v-layout>
	</button>
</template>
<script>
export default {
	name: 'btn-action',
	props: {
		action: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
<style lang="scss" scoped>
	.btn-action-image {
		background-color: color(white);
		border: solid 1px color(primary);
		border-radius: 15px;
		color: color(primary);
		display: inline-block;	
		text-decoration: none;
		margin-left: 30px;
		max-height: 230px;
		max-width: 214px;
		padding: 35px 42px;
		text-align: center;

		p {
			font-size: size(small13);
		}

		.text {
			font-size: size(medium16);
			margin: 10px auto 0;
		}

		.image {
			height: 61px;

			@media (max-width: 1024px) {
				height: 50px;
			}
		}

		&.btn-green {
			background-color: color(primary);
			color: color(white);
		}

		@media (max-width: 1024px) {
			height: 180px !important;
			margin-left: 0px;
			margin-bottom: 10px;
			width: 89%;
			padding: 10px;
		}

		.text-desktop {
			font-weight: 900;

			@media (max-width: 1024px) {
				display: none;
			}
		}

		.text-mobile {
			display: none;

			@media (max-width: 1024px) {
				display: block;
				font-family: font(lato-regular);
				font-weight: 900;
			}
		}
	}

	.content-btn {
		@media (max-width: 1024px) {
			align-items: center;
			flex-direction: column;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/shared/btn-action.vue